import { render } from "./LoginButton.vue?vue&type=template&id=f61c1362"
import script from "./LoginButton.vue?vue&type=script&lang=js"
export * from "./LoginButton.vue?vue&type=script&lang=js"
script.render = render

export default script